import { generateFlashcardCardId } from "@/components/flashcards/flashcardsCard/EditableFlashcardCard/utils";
import { Flashcard, FlashcardSet } from "@knowt/syncing/graphql/schema";
import { MIN_FLASHCARDS_COUNT, scrapeEmptyFlashcards } from "@knowt/syncing/hooks/flashcards/utils";
import { FlashcardSortable } from "../types";

export const getSavingErrorMessage = (error: Error, isCreateMode: boolean) => {
    if (exceededSizeError(error)) {
        return "Sorry unfortunately this set is too large to be added on to, please split it up. We’re working on a way to increase this!";
    }

    return isCreateMode ? "Error creating!" : "Error saving!";
};

const exceededSizeError = (error: Error) => {
    return /exceeded the maximum allowed size/i.test(error.message);
};

export const throwIfInputIsNotValid = async (flashcardSet?: FlashcardSet | null) => {
    if (!flashcardSet) throw new Error("FlashcardSet not in the cache!");
    if (!flashcardSet?.noteId && !flashcardSet.title) throw new Error("Please enter a deck name");
    if ((await scrapeEmptyFlashcards(flashcardSet.flashcards as Flashcard[])).length < MIN_FLASHCARDS_COUNT)
        throw new Error(`Please create at least ${MIN_FLASHCARDS_COUNT} non-empty flashcards!`);
};

export const flashcardsToSortable = ({ flashcards }: { flashcards: Flashcard[] }): FlashcardSortable[] => {
    return flashcards?.map((flashcard, index) => ({
        // generate flashcard card id for dnd-kit Sortable
        id: generateFlashcardCardId(flashcard.flashcardId),
        index,
        ...flashcard,
    }));
};
